import React, { useState } from "react";
import { Button } from "reactstrap";
import { OnlineBiddingStatus } from "../../../../constants/online-bidding-status";
import OnlineBiddingRegistrationModal from "../../../common/modal/online-bidding-registration-modal";
import { getBlackFlagStatus } from "../../../../reducers/account";
import { connect } from "react-redux";
import CommonModal from "../../../common/modal/common-modal";

const RegistrationButton = ({
  isRegistered,
  onRegisterClick,
  isGuest,
  setLoginModal,
  loginModalOpen,
  onlineBiddingStatus_ID,
  getBlackFlagStatus,
  user_ID,
}) => {
  const [
    showBiddingRegistrationModal,
    setShowBiddingRegistrationModal,
  ] = useState(false);
  const [showWarningModal, setWarningModal] = useState(false);
  const [blackFlagError, setBlackFlagError] = useState("");

  const checkBlackFlag = async () => {
    if (!user_ID) {
      return false;
    }
    const response = await getBlackFlagStatus({ user_ID: user_ID });
    if (response && response.payload.isBlackFlag) {
      setBlackFlagError(response.payload.message);
      setWarningModal(true);
      return true;
    }
    setBlackFlagError("");
    return false;
  };

  const handleClick = async () => {
    // Handle guests - just show login modal
    if (isGuest) {
      setLoginModal(!loginModalOpen);
      return;
    }

    // Handle already registered users - allow unregistering
    if (isRegistered) {
      onRegisterClick();
      return;
    }

    // For logged-in users trying to register, check black flag first
    const isBlackFlagged = await checkBlackFlag();
    if (isBlackFlagged) {
      return;
    }

    // Check if online bidding is disabled
    if (onlineBiddingStatus_ID === OnlineBiddingStatus.Disabled) {
      setShowBiddingRegistrationModal(true);
      return;
    }

    // Proceed with registration
    onRegisterClick();
  };

  return (
    <>
      <OnlineBiddingRegistrationModal
        isOpen={showBiddingRegistrationModal}
        toggle={() => setShowBiddingRegistrationModal(false)}
      />
      <CommonModal
        title="Error Registering For Event"
        isOpen={showWarningModal}
        toggle={() => setWarningModal(!showWarningModal)}
      >
        <div>{blackFlagError}</div>
      </CommonModal>
      <Button
        className={`mb-3 ${
          isRegistered ? "alert-success" : "alert-secondary"
        } w-100`}
        role="alert"
        style={{ cursor: "pointer" }}
        title={isRegistered ? "Click to unregister." : "Click to register"}
        onClick={handleClick}
      >
        <i
          className={`fa ${
            isRegistered ? "fa-check-circle good" : "fa-calendar boldLinkButton"
          } fa-2x`}
        >
          <span
            style={{
              fontFamily: "MyriadReg",
              fontSize: "14px",
              marginLeft: isRegistered ? "10px" : "15px",
              textTransform: "uppercase",
              verticalAlign: "middle",
            }}
          >
            {isRegistered ? "registered" : "register"}
          </span>
        </i>
      </Button>
    </>
  );
};
const mapDispatchToProps = {
  getBlackFlagStatus,
};

const mapStateToProps = (state) => ({
  user_ID: state.authorization.user_ID,
});
export default connect(mapStateToProps, mapDispatchToProps)(RegistrationButton);
